<!--主模板-->
<template>
  <header-bar/>
  <div class="wrap">
    <router-view/>
  </div>
</template>

<script lang="ts" setup>
import headerBar from "@/components/headerbar.vue";
</script>

<style lang="scss" scoped>
.wrap {
  padding-top: $HeaderHeight;
  height: calc(100% - #{$HeaderHeight});
  width: 100%;
}
</style>

<style lang="scss">
$footerHeight: 50px;
main {
  $space: 40px;
  padding-top: 20px;
  height: calc(100% - 10px - 20px);
  float: left;
  width: 100%;
  display: grid;
  grid-template-areas:
    "left head right"
    "left extop right"
    "left main right";
  grid-template-rows: auto auto 1fr;
  $sideSpace: 30px;
  grid-template-columns: $sideSpace 1fr $sideSpace;
  $topAreaHeight: 40px;

  .el-input.search {
    .el-input-group__append {
      padding-top: 0;
      border-bottom-width: 0;
    }
  }

  .topArea {
    display: flex;
    height: $topAreaHeight;
    align-items: center;

    // margin-bottom: 24px;
    .title {
      display: flex;
      align-items: center;
      flex-grow: 1;
      white-space: nowrap;
      font-size: 20px;
      font-weight: 500;
    }

    .el-input.search {
      align-items: center;
      width: 280px;

      .el-input__inner {
        border-left: none;
        border-right: none;
      }

      svg {
        margin-right: 0;
      }
    }

    .el-divider--vertical {
      height: 27px;
      margin: 0 12px;
    }

    .el-button.filter {
      padding-left: 0;
      padding-right: 0;
      color: #8b8b8b;
      margin-left: 10px;

      svg {
        font-size: 20px;
        margin-right: 0;
      }
    }
  }

  .exTop {
    grid-area: extop;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .layout {
    width: 100%;
    overflow-y: hidden;
    padding: 0 $sideSpace;
    grid-area: main;
    margin: 0 calc(0px - #{$sideSpace}) calc(0px - 24px);
    height: 100%;
    display: flex;

    $siderBarWidth: 230px;

    section {
      float: left;
    }

    &-sider-bar {
      width: $siderBarWidth;
      height: 100%;
      display: flex;
      transition: all 0.3s ease-in-out 0s;
      padding-right: $sideSpace;
      margin-right: $sideSpace;
      border-right: 1px solid #e8e8e8;
      flex-direction: column;
      position: relative;

      &-content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        transition: all 0.3s ease-in-out 0s;
        opacity: 1;

        &-header {
          height: 40px;
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          flex: 0 0 40px;
          padding-left: 8px;
          font-size: 18px;
          justify-content: space-between;

          svg {
            cursor: pointer;
            // color: #1b9aee;
            color: $ThemeColor;
            font-size: 20px;
            font-weight: 700;

            &:focus {
              outline: none;
            }

            &.not-allow {
              cursor: not-allowed;
            }
          }
        }

        .el-menu {
          position: relative;
          font-size: 14px;
          flex: 1;
          overflow-y: auto;
          padding: 0 8px;
          margin-left: -8px;
          border-right: none;

          &-item {
            display: flex;
            align-items: center;
            height: 36px;
            justify-content: space-between;
          }

          &-item:hover {
            background-color: #f7f7f7;

            .count:not(:last-child) {
              display: none;
            }

            .el-dropdown {
              display: block;
            }

            .menu-opt {
              opacity: 1;
            }
          }

          &-item.is-active {
            background-color: #f0f9ff;
          }
        }

        .tree-v2-wrap {
          height: 100%;
        }

        .el-tree {
          height: 100%;

          .el-tree-node {
            .el-tree-node__content {
              svg {
                padding-right: 3px;
              }

              .element-tree-node-label-wrapper {
                //width: calc(100% - 24px);
              }
            }
          }

          .el-tree-node:hover {
            > .el-tree-node__content {
              .element-tree-node-label-wrapper {
                .oper {
                  .count:not(:last-child) {
                    display: none;
                  }

                  .menu-opt {
                    opacity: 1;
                  }

                  .drowDown {
                    position: relative;

                    .drowDownBox {
                      position: absolute;
                      top: 0;
                    }
                  }
                }
              }
            }
          }
        }

        .tree-node {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .viewTitle {
          width: calc(100% - 23px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          .el-tooltip__trigger {
            display: flex;

            svg {
              margin-right: 5px;
            }

            > span {
              line-height: 16px;
            }
          }
        }

        .floor1 {
          max-width: 156px;
        }

        .floor2 {
          max-width: 140px;
        }

        .floor3 {
          max-width: 124px;
        }

        .floor4 {
          max-width: 109px;
        }

        .oper {
          width: 35px;
          height: 12px;
          padding-right: 10px;
          display: flex;
          justify-content: flex-end;
          position: relative;

          .count {
            line-height: 12px;
            color: rgba(139, 139, 139, 0.5);
            font-size: 12px;
            position: absolute;
            display: block;
          }

          .menu-opt {
            opacity: 0;
          }
        }
      }

      &-toggle {
        position: absolute;
        top: 8px;
        width: 24px;
        height: 24px;
        right: -12px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        border: 1px solid #e8e8e8;
        background-color: #fff;
        cursor: pointer;
        transition: all 0.2s ease-in-out 0s;
        z-index: 2;
      }

      &-toggle:hover {
        border-color: transparent;
        background-color: #1b9aee;
        color: #fff;
      }
    }

    .limitWidth {
      width: 170px;
    }

    &-sider-bar.closed {
      width: 0;
      padding-right: 0;
      margin-right: 12px;

      .layout-sider-bar-toggle {
        transform: rotate(-180deg);
      }

      .layout-sider-bar-content {
        opacity: 0;
      }
    }

    &-content {
      width: calc(100% - #{$space} * 1.5 - #{$siderBarWidth} - 1px);
      height: 100%;
      flex: 1 1;
      display: flex;
      flex-direction: column;
      transition: all 0.3s ease-in-out 0s;

      .filterWrap {
        margin: 0 0 20px;
        background-color: #f7f7f7;
        padding: 24px 0 24px 32px;
        border-radius: 8px;

        .btns {
          padding-right: 32px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 4px;
        }

        .el-form {
          padding-right: 32px;
        }
      }

      // 操作列公共处理
      .action_column {
        .cell {
          text-overflow: clip;
        }

        .el-button-group + .el-button-group {
          margin-left: 5px;
        }

        .el-button-group.order {
          .el-button:nth-of-type(n + 3) {
            transform: rotate(180deg);
          }
        }
      }

      .el-scrollbar {
        height: 100%;
        border-bottom: 1px solid #e8e8e8;

        .el-scrollbar__view {
          .NoTable {
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            justify-content: space-between;
          }

          .NewNoTable {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            column-gap: 20px;
          }
        }
      }
    }

    &-content.full {
      padding-left: $space;
      width: calc(100% - #{$space} - 12px - 1px);
    }

    &-content.full:first-child,
    &-content:first-child {
      padding-left: 0;
      width: 100%;
    }
  }
}


.table-box {
  // height: 100%;
  flex-grow: 1;
  overflow-y: auto;
  position: relative;

  .el-table {
    height: 100%;
    border-bottom: 1px solid #e8e8e8;
    $headerHeight: 49px;

    &__inner-wrapper::before {
      background: transparent;
    }

    &__inner-wrapper {
      height: 100%;

      .el-table__body-wrapper {
        height: calc(100% - #{$headerHeight});
        overflow-y: auto;

        .el-scrollbar__view {
          height: 100%;

          .el-table__empty-block {
            height: 70% !important;
          }
        }
      }
    }

    &__header {
      thead {
        tr {
          th.el-table__cell {
            border-bottom-color: #e8e8e8 !important;
            color: #8b8b8b;

            .cell.HeaderSlot {
              display: flex;
              align-items: center;

              .caret-wrapper {
                margin-right: 10px;
                margin-left: 0;
              }

              .el-select {
                .el-input__wrapper {
                  .el-input__inner {
                    padding: 0;
                    color: #8b8b8b;
                    font-size: 14px;
                    font-weight: 700;
                  }
                }
              }
            }
          }
        }
      }
    }

    &__body {
      $RowHeight: 30px;

      tbody {
        tr {
          td {
            height: $RowHeight;
            padding: 7.5px 0 !important;
            color: #999;
            vertical-align: middle;
            border-bottom: none;

            .el-tag--mini {
              padding: 0 10px;
            }
          }

          td:first-child {
            padding: 5px 0;
          }
        }
      }

      .btn-op {
        font-size: 13px;
        padding: 12px 10px;
        margin: 0 4px;
      }

      .more-ops-container {
        font-size: 13px;
        vertical-align: middle;
        cursor: pointer;

        .text-wrapper {
          label {
            cursor: pointer;
            color: $ThemeColor;
          }

          .el-icon-caret-bottom {
            margin-left: 5px;
          }
        }
      }
    }

    .cell {
      padding-left: 5px;
      padding-right: 5px;

      .el-table__placeholder {
        display: none;
      }

      .el-checkbox {
        height: 32px;
      }
    }
  }


  .el-pagination__sizes {
    margin-right: 0;
  }
}

.table-box + .el-footer {
  height: $footerHeight;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;

  .foot-right {
    display: flex;
    align-items: center;

    .lesson-content {
      margin-right: 20px;
      color: #606266;
      font-size: 14px;
    }
  }

  .el-pagination {
    padding: 0;
    font-size: 14px;

    &__total {
      color: #cecece;
    }

    &__sizes {
      margin: 0 0 0 16px;
    }

    button,
    .el-pager li {
      width: 28px;
      padding: 0;
      border-color: transparent;
      border-width: 1px;
      border-radius: 4px;
      min-width: 32px;
      color: #575757;
      background: transparent;
      display: block;
    }

    button:hover,
    .el-pager li:hover {
      color: rgb(79, 162, 249);
      //background: #e8e8e8;
    }

    .el-pager {
      margin: 0 8px;

      li.is-active {
        color: rgb(6, 111, 220);
      }

      li + li {
        margin-left: 8px;
      }
    }

    button:disabled {
      background-color: #ffffff;
      color: #a8abb2;
    }
  }

  > div {
    .el-button-group {
      > .el-dropdown {
        > .el-button {
          border-left-color: #dcdfe6;
        }
      }
    }
  }
}

.table-box:first-child {
  margin-top: 24px;
}

main:after,
main:before {
  content: " ";
  padding-right: 24px;
}

main:before {
  grid-area: left;
}

main:after {
  grid-area: right;
}

.el-dropdown__popper {
  .el-dropdown-menu__item {
    svg {
      margin-right: 5px;
    }
  }
}
</style>